import React, { Fragment, useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Main from "../../layout/main";
import { StudentsStatusService } from "../../services/competitions";
import Header from "../../components/common/secondary header/index";
import "./style.scss";
import { Spinner } from "react-bootstrap";
import { textIdentifier } from "../../textIdentifier";
import CompetitonResetModal from "./CompetitonResetModal";

const EVENTS = ["competition", "warmup", "practice"];
const EVENTS_CON = ["competition", "practice"]
const STATUSES = ["not_done", "ongoing", "finished"];

const ActionTooltip = ({children}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef(null);
  const tooltipIconRef = useRef(null);

  const handleClick = () => {
    setShowTooltip(prev => true);
  };

  const handleClickOutside = (event) => {
    if (tooltipRef.current && tooltipIconRef.current && !tooltipIconRef.current.contains(event.target) &&   !tooltipRef.current.contains(event.target)) {
      setShowTooltip(false);
    }
  };

  useEffect(() => {
    if (showTooltip) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [showTooltip]);

  return (
   <div
      ref={tooltipIconRef}
      onClick={handleClick}
    >
      {children}
     {showTooltip && <div className="action-tooltip-cnt" ref={tooltipRef}>
      You can either reschedule the competition or allow the student to reattempt it. (n) represents the number of times you have permitted the student to reschedule or reattempt the competition
      </div>}
    </div>
  );
}

const RescheduleInfoTooltop = ({rescheduleInfo,children}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => {
    setShowTooltip(prev => true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(prev => false);
  }

  const handleDateFormat=(date)=>{
    if(!date)
      return ""
    const utcDate = new Date(date);

    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return utcDate.toLocaleDateString('en-GB', options);
  }

  return (
   <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
     {showTooltip && <div className="reschedule-info-tooltip">
      <div className="reset-tooltip-row">Your last update:</div>
      <div className="reset-tooltip-row">{`Start date: ${handleDateFormat(rescheduleInfo.start_time)}`}</div>
      <div className="reset-tooltip-row">{`End date: ${handleDateFormat(rescheduleInfo.end_time)}`}</div>
      </div>}
    </div>
  );
}

const ViewStatus = () => {
  const { selectedCompetition, selectedSchool, selectedClass, lang } = useSelector(
    (state) => state.main
  );
  const navigate = useNavigate();
  const [students, setStudents] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [isResetModalOpen,setIsResetModalOpen] = useState(false);
  const [currentResetStudent, setCurrentResetStudent] = useState(undefined);

  const handleCloseResetModal = () => {
    setIsResetModalOpen(prev=>false);
  }

  const handleResheduledClick = (student)=>{
    setIsResetModalOpen(prev=>true);
    setCurrentResetStudent(student);
  }

  const fetchStudentsStatus = async () => {
    try {
      if (!isFetching) setIsFetching(true);
      const res = await StudentsStatusService(
        selectedCompetition.id,
        selectedClass.code
      );
      setStudents(res.data);
    } catch (e) {
      console.error("Error fetching students status: ", e);
    } finally {
      setIsFetching(false)
    }
  };

  useEffect(() => {
    if (!selectedCompetition || !selectedSchool || !selectedClass) {
      navigate(`/schools`);
    } else {
      fetchStudentsStatus();
    }
  }, []);

  const getStatusBadge = (status, count) => {
    switch (status) {
      case STATUSES[0]:
        return (
          <div className="chip chip-warning">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10Z"
                stroke="#2E2E2E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.5 8.33333C7.5 8.11232 7.5878 7.90036 7.74408 7.74408C7.90036 7.5878 8.11232 7.5 8.33333 7.5H11.6667C11.8877 7.5 12.0996 7.5878 12.2559 7.74408C12.4122 7.90036 12.5 8.11232 12.5 8.33333V11.6667C12.5 11.8877 12.4122 12.0996 12.2559 12.2559C12.0996 12.4122 11.8877 12.5 11.6667 12.5H8.33333C8.11232 12.5 7.90036 12.4122 7.74408 12.2559C7.5878 12.0996 7.5 11.8877 7.5 11.6667V8.33333Z"
                stroke="#2E2E2E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>{textIdentifier["not-done"][lang]}{count || count === 0 ? `: ${count}` : ""}</span>
          </div>
        );
      case STATUSES[1]:
        return (
          <div className="chip chip-success">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="10"
              viewBox="0 0 18 14"
              fill="none"
            >
              <path
                d="M3.69673 12.3034C3.00028 11.607 2.44783 10.7802 2.07091 9.87026C1.694 8.96031 1.5 7.98503 1.5 7.00011C1.5 6.01519 1.694 5.03991 2.07091 4.12996C2.44783 3.22002 3.00028 2.39322 3.69673 1.69678M14.3034 1.69678C14.9998 2.39322 15.5523 3.22002 15.9292 4.12996C16.3061 5.03991 16.5001 6.01519 16.5001 7.00011C16.5001 7.98503 16.3061 8.96031 15.9292 9.87026C15.5523 10.7802 14.9998 11.607 14.3034 12.3034M6.0534 9.94595C5.27227 9.16458 4.83345 8.10496 4.83345 7.00011C4.83345 5.89526 5.27227 4.83564 6.0534 4.05428M11.9467 4.05428C12.7279 4.83564 13.1667 5.89526 13.1667 7.00011C13.1667 8.10496 12.7279 9.16458 11.9467 9.94595M9.8334 7.00011C9.8334 7.22112 9.7456 7.43309 9.58932 7.58937C9.43304 7.74565 9.22108 7.83344 9.00006 7.83344C8.77905 7.83344 8.56709 7.74565 8.41081 7.58937C8.25453 7.43309 8.16673 7.22112 8.16673 7.00011C8.16673 6.7791 8.25453 6.56714 8.41081 6.41086C8.56709 6.25458 8.77905 6.16678 9.00006 6.16678C9.22108 6.16678 9.43304 6.25458 9.58932 6.41086C9.7456 6.56714 9.8334 6.7791 9.8334 7.00011Z"
                stroke="#2E2E2E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>{textIdentifier["ongoing"][lang]}{count || count === 0 ? `: ${count}` : ""}</span>
          </div>
        );
      case STATUSES[2]:
        return (
          <div className="chip chip-danger">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="10"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                d="M14.3034 14.3034L3.69671 3.69671M14.3034 14.3034C15.7099 12.8968 16.5001 10.9892 16.5001 9.00005C16.5001 7.01091 15.7099 5.10324 14.3034 3.69671C12.8968 2.29018 10.9892 1.5 9.00005 1.5C7.01091 1.5 5.10324 2.29018 3.69671 3.69671L14.3034 14.3034ZM14.3034 14.3034C12.8968 15.7099 10.9892 16.5001 9.00005 16.5001C7.01091 16.5001 5.10324 15.7099 3.69671 14.3034C2.29018 12.8968 1.5 10.9892 1.5 9.00005C1.5 7.01091 2.29018 5.10324 3.69671 3.69671L14.3034 14.3034Z"
                stroke="#2E2E2E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>{textIdentifier["finished"][lang]}{count || count === 0 ? `: ${count}` : ""}</span>
          </div>
        );
      default:
        return null;
    }
  };

  const getTotal = (event, status) => {
    return students.reduce(
      (total, student) =>
        student[`${event}_status`] == status ? total + 1 : total,
      0
    );
  };

  const getStatusBadgeWithTotal = (event, status) =>
    getStatusBadge(status, getTotal(event, status));

  const startTime = new Date(selectedCompetition?.start_time);
  const endTime = new Date(selectedCompetition?.end_time);

  const renderTimeStringJSX = (start_time, end_time) => {
    const startTime = new Date(start_time);
    const endTime = new Date(end_time);

    function getDateString(date) {
      if(!date) return;
      const d = new Date(date).toJSON();
      return d && d.split("T")[0].split("-").reverse().join("-");
    }

    return (
      <Fragment>
        <span>{getDateString(startTime)} </span>
        <span className="text-primary">
          {startTime
            .toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })
            .toLowerCase()}{" "}
        </span>
        <span>to </span>
        <span>{getDateString(endTime)} </span>
        <span className="text-primary">
          {endTime
            .toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })
            .toLowerCase()}{" "}
        </span>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <Header />
      <Main className={"competition-school-classes-view-status"}>
        <div className="cr-wrapper-card">
          <div className="cr-card-header justify-content-start">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 35 35"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M21.78 3.66699H10.2213C6.1933 3.66699 3.66797 6.51899 3.66797 10.555V21.4457C3.66797 25.4817 6.17997 28.3337 10.2213 28.3337H21.7786C25.82 28.3337 28.3346 25.4817 28.3346 21.4457V10.555C28.3346 6.51899 25.82 3.66699 21.78 3.66699Z"
                  stroke="#2E2E2E"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16 11V16.3333L20 20.3333"
                  stroke="#2E2E2E"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>{textIdentifier["from"][lang]} :</span>
            </div>

            <div>{renderTimeStringJSX(startTime, endTime)}</div>
          </div>

          <ol className="breadcrumb">
            <li
              className="breadcrumb-item"
              onClick={() => navigate(`/schools`)}
            >
              <span>{selectedCompetition?.name}</span>
            </li>

            <li className="breadcrumb-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="24"
                viewBox="0 0 14 30"
                fill="none"
              >
                <path
                  d="M4.45149 28.6315C4.27728 29.2166 3.95371 29.5946 3.48083 29.7652C3.03283 29.9603 2.57238 29.9846 2.09949 29.8383C1.65149 29.7164 1.30305 29.4604 1.05416 29.0703C0.780383 28.6803 0.743049 28.1804 0.942161 27.5709L9.56616 1.34919C9.76528 0.764046 10.0888 0.373955 10.5368 0.178903C10.9848 -0.0161448 11.4328 -0.0405265 11.8808 0.105759C12.3537 0.227669 12.7146 0.495852 12.9635 0.910332C13.2373 1.30042 13.2746 1.78805 13.0755 2.37319L4.45149 28.6315Z"
                  fill="#2E2E2E"
                />
              </svg>
            </li>

            <li
              className="breadcrumb-item"
              onClick={() => navigate(`/schools/${selectedSchool?.id}/classes`)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  d="M7.66667 15.6667V19.6667V15.6667ZM13 15.6667V19.6667V15.6667ZM18.3333 15.6667V19.6667V15.6667ZM1 25H25H1ZM1 10.3333H25H1ZM1 6.33333L13 1L25 6.33333H1ZM2.33333 10.3333H23.6667V25H2.33333V10.3333Z"
                  stroke="#0059B1"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>{selectedSchool?.name}</span>
            </li>

            <li className="breadcrumb-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="24"
                viewBox="0 0 14 30"
                fill="none"
              >
                <path
                  d="M4.45149 28.6315C4.27728 29.2166 3.95371 29.5946 3.48083 29.7652C3.03283 29.9603 2.57238 29.9846 2.09949 29.8383C1.65149 29.7164 1.30305 29.4604 1.05416 29.0703C0.780383 28.6803 0.743049 28.1804 0.942161 27.5709L9.56616 1.34919C9.76528 0.764046 10.0888 0.373955 10.5368 0.178903C10.9848 -0.0161448 11.4328 -0.0405265 11.8808 0.105759C12.3537 0.227669 12.7146 0.495852 12.9635 0.910332C13.2373 1.30042 13.2746 1.78805 13.0755 2.37319L4.45149 28.6315Z"
                  fill="#2E2E2E"
                />
              </svg>
            </li>

            <li className="breadcrumb-item active">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 26 24"
                fill="none"
              >
                <path
                  d="M7.66667 22.6673V12.6673L13 9.70465M13 14.6673L25 8.00065L13 1.33398L1 8.00065L13 14.6673ZM13 14.6673L21.2133 10.1047C22.294 12.8488 22.6007 15.8369 22.1 18.7433C18.7181 19.0716 15.5296 20.4721 13 22.7407C10.4707 20.4724 7.28278 19.0718 3.90133 18.7433C3.40027 15.8369 3.70698 12.8487 4.788 10.1047L13 14.6673Z"
                  stroke="#2E2E2E"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>{`${selectedClass?.name} (${selectedClass?.code})`}</span>
            </li>
          </ol>

          <div className="cr-card">
            <table className="table cr-table">
              <thead>
                <tr>
                  <th scope="col" className="col-1">
                    <h5>{textIdentifier["no"][lang]}.</h5>
                  </th>
                  <th scope="col" className="col-5">
                    <h5>{textIdentifier["student-name"][lang]}</h5>
                  </th>
                  <th scope="col" className="col-2">
                    <h5>{textIdentifier["competition"][lang]}</h5>
                  </th>
                  {
                    !!selectedCompetition?.has_warmup
                    &&
                    <th scope="col" className="col-2">
                      <h5>{textIdentifier["warm-up"][lang]}</h5>
                    </th>
                  }
                  <th scope="col" className="col-2">
                    <h5>{textIdentifier["practise"][lang]}</h5>
                  </th>
                  <th scope="col" className="col-2 action-col">
                    <h5 className="action-text">{textIdentifier["action"][lang]}</h5>
                    <ActionTooltip>
                      <div className="info-icon-cnt">
                        <img src="/static/images/svg/info-icon.svg" alt="info icon" />
                      </div>
                    </ActionTooltip>
                  </th>
                </tr>
              </thead>
              <tbody>
                {students.map((student, index) => (
                  <tr key={student.id}>
                    <th scope="row" className="col-1">
                      {index + 1}
                    </th>
                    <td className="col-5">{`${student.first_name} ${student.last_name}`}</td>
                    <td className="col-2">
                      {getStatusBadge(student.competition_status)}
                    </td>
                    {
                      !!selectedCompetition?.has_warmup
                      &&
                      <td className="col-2">
                        {getStatusBadge(student.warmup_status)}
                      </td>
                    }
                    <td className="col-2">
                      {getStatusBadge(student.practice_status)}
                    </td>
                    <td className="col-2">
                    {
                      student.competition_status==="not_done" && Object.keys(student.reschedule).length>0 ? <RescheduleInfoTooltop rescheduleInfo={student.reschedule}>
                          <button className={"rescheduled-btn"} onClick={()=>handleResheduledClick(student)}>
                          {`${textIdentifier["rescheduled"][lang]} ${Object.keys(student.reschedule).length>0 ? `(${student.reschedule.reset_count})` : ""}`} 
                          </button>
                        </RescheduleInfoTooltop> : <button className="reschedule-btn" onClick={()=>handleResheduledClick(student)}>
                          {`${textIdentifier["reschedule"][lang]} ${Object.keys(student.reschedule).length>0 ? `(${student.reschedule.reset_count})` : ""}`} 
                      </button>
                    }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="card-footer border-0 bg-white">
              <div className="row">
                <div className="col-6 align-self-center">
                  <div className="flex-items">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="24"
                      viewBox="0 0 30 24"
                      fill="none"
                    >
                      <path
                        d="M21.666 22.6673H28.3327V20.0006C28.3326 19.1694 28.0736 18.3587 27.5915 17.6815C27.1095 17.0042 26.4284 16.494 25.643 16.2217C24.8576 15.9493 24.0068 15.9285 23.209 16.162C22.4112 16.3955 21.706 16.8718 21.1913 17.5246M21.666 22.6673L21.1913 17.5246M21.666 22.6673H8.33268M21.666 22.6673V20.0006C21.666 19.126 21.498 18.29 21.1913 17.5246M21.1913 17.5246C20.6962 16.2873 19.8417 15.2266 18.738 14.4795C17.6343 13.7324 16.3321 13.333 14.9993 13.333C13.6666 13.333 12.3644 13.7324 11.2607 14.4795C10.157 15.2266 9.30249 16.2873 8.80735 17.5246M8.33268 22.6673H1.66602V20.0006C1.66608 19.1694 1.92513 18.3587 2.40716 17.6815C2.8892 17.0042 3.57026 16.494 4.35568 16.2217C5.1411 15.9493 5.99185 15.9285 6.78967 16.162C7.58748 16.3955 8.29272 16.8718 8.80735 17.5246M8.33268 22.6673L8.80735 17.5246M8.33268 22.6673V20.0006C8.33268 19.126 8.50068 18.29 8.80735 17.5246M18.9993 5.33398C18.9993 6.39485 18.5779 7.41227 17.8278 8.16241C17.0776 8.91256 16.0602 9.33398 14.9993 9.33398C13.9385 9.33398 12.9211 8.91256 12.1709 8.16241C11.4208 7.41227 10.9993 6.39485 10.9993 5.33398C10.9993 4.27312 11.4208 3.2557 12.1709 2.50556C12.9211 1.75541 13.9385 1.33398 14.9993 1.33398C16.0602 1.33398 17.0776 1.75541 17.8278 2.50556C18.5779 3.2557 18.9993 4.27312 18.9993 5.33398ZM26.9993 9.33398C26.9993 10.0412 26.7184 10.7195 26.2183 11.2196C25.7182 11.7197 25.0399 12.0007 24.3327 12.0007C23.6254 12.0007 22.9472 11.7197 22.4471 11.2196C21.947 10.7195 21.666 10.0412 21.666 9.33398C21.666 8.62674 21.947 7.94846 22.4471 7.44837C22.9472 6.94827 23.6254 6.66732 24.3327 6.66732C25.0399 6.66732 25.7182 6.94827 26.2183 7.44837C26.7184 7.94846 26.9993 8.62674 26.9993 9.33398ZM8.33268 9.33398C8.33268 10.0412 8.05173 10.7195 7.55163 11.2196C7.05154 11.7197 6.37326 12.0007 5.66602 12.0007C4.95877 12.0007 4.28049 11.7197 3.7804 11.2196C3.2803 10.7195 2.99935 10.0412 2.99935 9.33398C2.99935 8.62674 3.2803 7.94846 3.7804 7.44837C4.28049 6.94827 4.95877 6.66732 5.66602 6.66732C6.37326 6.66732 7.05154 6.94827 7.55163 7.44837C8.05173 7.94846 8.33268 8.62674 8.33268 9.33398Z"
                        stroke="#2E2E2E"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className="m-0">
                      {textIdentifier["total-students"][lang]} : {isFetching ? textIdentifier["fetching"][lang]+"..." : students.length}
                    </span>
                  </div>
                </div>
                {students.length > 0 && (
                  <div className="col-6 d-block">
                    <div style={{justifyContent: "space-around"}} className="row">
                      {
                        !!selectedCompetition?.has_warmup?
                        EVENTS.map((event) => (
                          <div className="col-4">
                            <div className="chip-container">
                              {STATUSES.map((status) =>
                                getStatusBadgeWithTotal(event, status)
                              )}
                            </div>
                          </div>
                        ))
                        :
                        EVENTS_CON.map((event) => (
                          <div className="col-4">
                            <div className="chip-container">
                              {STATUSES.map((status) =>
                                getStatusBadgeWithTotal(event, status)
                              )}
                            </div>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {
          isResetModalOpen && <CompetitonResetModal setStudents={setStudents} student={currentResetStudent} handleClose={handleCloseResetModal}/>
        }
      </Main>
    </Fragment>
  );
};

export default ViewStatus;
